import React from 'react';

const TrendingUp = () => <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6459 1.0541L16.0859 2.4941L11.2059 7.3741L7.91588 4.0841C7.72905 3.89685 7.4754 3.79162 7.21088 3.79162C6.94636 3.79162 6.69271 3.89685 6.50588 4.0841L0.505879 10.0941C0.115879 10.4841 0.115879 11.1141 0.505879 11.5041C0.895879 11.8941 1.52588 11.8941 1.91588 11.5041L7.20588 6.2041L10.4959 9.4941C10.8859 9.8841 11.5159 9.8841 11.9059 9.4941L17.4959 3.9141L18.9359 5.3541C19.2459 5.6641 19.7859 5.4441 19.7859 5.0041V0.704102C19.7959 0.424102 19.5759 0.204102 19.2959 0.204102H15.0059C14.5559 0.204102 14.3359 0.744102 14.6459 1.0541Z" fill="currentColor"/>
</svg>


export default TrendingUp;
